import React, { useState, useEffect } from "react"
import { Col, Image, Input, Row, Space, Tree, Typography } from "antd"
import PageHeader from "../../../components/Elements/PageHeader"
import {
  FileOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileTextOutlined,
} from "@ant-design/icons"
import { getDownloadURL, listAll, ref } from "firebase/storage"
import { storage } from "../../../firebase/config"

const { Text } = Typography

export default function PlateFiles() {
  const [treeData, setTreeData] = useState([])
  const [loading, setLoading] = useState(false)

  //search
  const [searchValue, setSearchValue] = useState("")

  //selected file
  const [selectedFile, setSelectedFile] = useState(null)
  const [selectedFileURL, setSelectedFileURL] = useState(null)

  //get the folders from storage
  useEffect(() => {
    const fetchRootFolders = async () => {
      const storageRef = ref(storage, "arsomaPlates")
      const results = await listAll(storageRef)
      const transformedData = results.prefixes.map((folder) => ({
        title: folder.name,
        key: `arsomaPlates/${folder.name}`,
      }))
      setTreeData(transformedData)
    }

    setLoading(true)
    fetchRootFolders().then(() => setLoading(false))
  }, [])

  //gets the selected file
  useEffect(() => {
    const fetchURL = async () => {
      if (selectedFile) {
        const fileRef = ref(storage, selectedFile) // Make sure you're using a Storage Reference
        const url = await getDownloadURL(fileRef)
        setSelectedFileURL(url)
        console.log(url)
      } else {
        setSelectedFileURL(null)
      }
    }

    fetchURL()
  }, [selectedFile])

  //update the tree data
  const updateTreeData = (list, key, children) =>
    list.map((node) => {
      if (node.key === key) {
        return { ...node, children }
      }
      if (node.children) {
        return {
          ...node,
          children: updateTreeData(node.children, key, children),
        }
      }
      return node
    })

  //handle tree select, what happens when you select a tree
  const handleTreeSelect = (_, { selectedNodes }) => {
    if (selectedNodes[0] && selectedNodes[0].isLeaf) {
      setSelectedFile(selectedNodes[0].key)
    } else {
      setSelectedFile(null)
    }
  }

  //chose  a file icon
  const determineFileIcon = (filename) => {
    const extension = filename.split(".").pop().toLowerCase()

    switch (extension) {
      case "png":
      case "jpg":
      case "jpeg":
        return <FileImageOutlined style={{ fontSize: "18px" }} />
      case "pdf":
        return <FilePdfOutlined style={{ fontSize: "18px" }} />
      case "doc":
      case "docx":
        return <FileWordOutlined style={{ fontSize: "18px" }} />
      case "txt":
        return <FileTextOutlined style={{ fontSize: "18px" }} />
      default:
        return <FileOutlined style={{ fontSize: "18px" }} />
    }
  }

  //on load data
  const onLoadData = (treeNode) =>
    new Promise(async (resolve) => {
      if (treeNode.children) {
        resolve()
        return
      }
      const storageRef = ref(storage, treeNode.key)
      const results = await listAll(storageRef)
      const children = [
        ...results.prefixes.map((folder) => ({
          title: folder.name,
          key: `${treeNode.key}/${folder.name}`,
        })),
        ...results.items.map((file) => ({
          title: (
            <span>
              {determineFileIcon(file.name)} {file.name}
            </span>
          ), // Modify this line
          key: `${treeNode.key}/${file.name}`,
          isLeaf: true,
        })),
      ]
      const newData = updateTreeData(treeData, treeNode.key, children)
      setTreeData(newData)
      resolve()
    })

  //icons switcher
  const renderSwitcherIcon = ({ isLeaf, expanded }) => {
    if (isLeaf) {
      return null // default icon for leaf item
    }
    return expanded ? (
      <FolderOpenOutlined style={{ fontSize: "18px" }} />
    ) : (
      <FolderOutlined rotate={360} style={{ fontSize: "18px" }} />
    )
  }

  //searching the folders
  const searchTree = (nodes, query) => {
    let result = []
    for (let node of nodes) {
      if (typeof node.title === "string" && node.title.includes(query)) {
        result.push(node)
        continue
      }
      if (node.children) {
        let childResults = searchTree(node.children, query)
        if (childResults.length) {
          result.push({ ...node, children: childResults })
        }
      }
    }
    return result
  }

  //file types for display
  const renderFilePreview = () => {
    const fileExtension = selectedFile ? selectedFile.split(".").pop().toLowerCase() : null

    switch (fileExtension) {
      case "png":
      case "jpg":
      case "jpeg":
        return <Image src={selectedFileURL} alt="Selected File Preview" width="100%" />
      case "pdf":
        return <FileOutlined style={{ fontSize: "50px" }} />
      default:
        return <FileOutlined style={{ fontSize: "50px" }} />
    }
  }

  return (
    <div style={{ padding: 15 }}>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <PageHeader text="Plate Files" icon={<FileOutlined />} />
        </Col>
        <Col span={6}>
          <Space>
            <Text>Search :</Text>
            <Input
              placeholder="POLI..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </Space>
        </Col>
        <Col span={18}></Col>
        <Col span={12}>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <Tree
              style={{ padding: 25 }}
              loadData={onLoadData}
              switcherIcon={renderSwitcherIcon}
              treeData={searchValue ? searchTree(treeData, searchValue) : treeData}
              onSelect={handleTreeSelect}
            />
          )}
        </Col>
        <Col span={12}>
          <div style={{ background: "white", padding: 15, borderRadius: 5, height: "100%" }}>
            {selectedFileURL && renderFilePreview()}
          </div>
        </Col>
      </Row>
    </div>
  )
}
